export default __webpack_public_path__ + "powered_by_google_default.e5a04343aad99c9d6fd93f0ab5562c8c.png";